import { useEffect, useState } from 'react';

import { NAVBAR_HEIGHT, NAVBAR_SCROLL_OFFSET } from '@constants/variables';
import { TableOfContentsItem } from '@components/containers/TableOfContents/TableOfContents.props';
import { useRouter } from 'next/router';

export const useHeadings = (target: string): TableOfContentsItem[] => {
  const router = useRouter();
  const [headings, setHeadings] = useState<TableOfContentsItem[]>([]);

  useEffect(() => {
    const arr = Array.from(document.querySelectorAll<HTMLHeadingElement>(target)).map((element) => {
      return {
        label: element.innerText,
        onClick: () => {
          const { top } = element.getBoundingClientRect();
          window.scrollTo({
            top: top + window.pageYOffset - NAVBAR_HEIGHT + NAVBAR_SCROLL_OFFSET,
            behavior: 'smooth',
          });
        },
      };
    });

    setHeadings(arr);
  }, [target, router.query]);

  return headings;
};
